/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Pit3_TInputs */

const en_to_typescript_pit3_t = /** @type {(inputs: To_Typescript_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generated types describe your sample, not the API contract`)
};

const ko_to_typescript_pit3_t = /** @type {(inputs: To_Typescript_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성된 타입은 API 계약이 아니라 샘플을 서술합니다`)
};

const ja_to_typescript_pit3_t = /** @type {(inputs: To_Typescript_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成された型は API の契約ではなくサンプルを記述します`)
};

/**
* | output |
* | --- |
* | "Generated types describe your sample, not the API contract" |
*
* @param {To_Typescript_Pit3_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_pit3_t = /** @type {((inputs?: To_Typescript_Pit3_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Pit3_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_pit3_t(inputs)
	if (locale === "ko") return ko_to_typescript_pit3_t(inputs)
	return ja_to_typescript_pit3_t(inputs)
});